// extracted by mini-css-extract-plugin
export default {"pageWrapper":"eFileSupport_pageWrapper__Ua9Yd","tabs":"eFileSupport_tabs__Q1nce"};